import React from 'react';
import {NavLink} from 'react-router-dom';
import {IStyleguideRoute} from '../../types/types';

/**
 * Свойства компонента.
 *
 * @prop {string} label Лэйбл.
 * @prop {string} path Роут куда перебросит при нажатии на пункт меню.
 * @prop {IStyleguideRoute[]} children Массив пунктов, которые являются подменю.
 */
interface IMenuListLinkProps {
    label: string;
    path: string;
    children?: IStyleguideRoute[];
}

/**
 * Ссылка пункта меню.
 */
const MenuListLink: React.FC<IMenuListLinkProps> = ({label, path}) => (
    <NavLink
        to={(location: any) => '/' + path + location.search}
        className="menu-list-link"
        activeClassName="selected"
        isActive={(match) => Boolean(match)}
    >
        <span>{label}</span>
    </NavLink>
);

export default MenuListLink;
